import React from 'react';
import Loading from '../../components/Loading/Loading.jsx';
import getFileData, { fetchPublicDataFile } from '../../APICall/Api.jsx';

class SectionPublications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      url: getFileData,
    };
  }

  callAPI = (lang) => {
    fetchPublicDataFile(`Publications${lang.capitalize()}.json`)
      .then(
        (result) => this.setState({ isLoaded: true, items: result.publications }),
        (error)  => this.setState({ isLoaded: true, error }),
      );
  };

  componentDidMount()              { this.callAPI(this.props.lang); }
  componentWillReceiveProps(next)  {
    if (next.lang !== this.props.lang) {
      this.setState({ isLoaded: false });
      this.callAPI(next.lang);
    }
  }

  render() {
    if (this.state.error)    return <div>Error loading publications.</div>;
    if (!this.state.isLoaded) return <Loading />;

    return (
      <section className="bgg-section bgg-section-white bgg-publications-section">
        <div className="bgg-container">
          <div className="bgg-section-header">
            <span className="bgg-section-label">Research & Reports</span>
            <div>
              <h2 className="bgg-section-title">{this.props.title || 'Publications'}</h2>
            </div>
          </div>

          <div className="bgg-pub-grid">
            {this.state.items.map((item, key) => (
              <div className="bgg-pub-card" key={key}>
                <div className="bgg-pub-icon">
                  <i className="fas fa-file-pdf" />
                </div>
                <div className="bgg-pub-title">{item.title}</div>
                {item.description && (
                  <p style={{ color: 'var(--bgg-text-mid)', fontSize: '0.88rem', lineHeight: 1.65, margin: 0 }}>
                    {item.description.substring(0, 100)}{item.description.length > 100 ? '…' : ''}
                  </p>
                )}
                {(item.link || item.url || item.path) && (
                  <a
                    href={item.link || item.url || item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bgg-btn bgg-btn-outline bgg-btn-sm"
                    style={{ alignSelf: 'flex-start' }}
                  >
                    <i className="fas fa-download" />
                    {this.props.publicationButton || 'Download'}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default SectionPublications;



// WEBPACK FOOTER //
// ./src/views/Publications/SectionPublications.jsx